import { ModalPlugin } from '@/plugins/modal/plugin'

export default {
  install: (app) => {
    const modalsPlugin = new ModalPlugin()
    app.provide('modalsPlugin', modalsPlugin)
  },
}
